import { useAuth } from "../context/authContext";

const usePermissions = () => {
    const { permissions } = useAuth();
    const can = (permission) => Array.isArray(permissions) && permissions.includes(permission);
    return { can };
};

export default usePermissions;
